module.exports = __webpack_public_path__ + "img/pendApprovalIconUS.f67fb67d.png";